<script setup lang="ts">
// PROPS
import type { DirectSaleListingItemEntity } from '~/apiClient';

const { directSale } = defineProps({
    directSale: { type: Object as PropType<DirectSaleListingItemEntity>, required: true },
});

// COMPOSABLES
const { title } = useDirectSaleStatus(toRef(() => directSale));

// DATA
</script>

<template>
    <p class="tracking-wide uppercase">{{ title }}</p>
</template>
